import React from "react";
import { Card, Radio } from "antd";
import PostsChart from "./PostsChart";

function PostsAnalysisCard({
  posts,
  loading,
  availableYears,
  selectedYear,
  setSelectedYear,
  setViewMode,
  viewMode,
}) {
  return (
    <Card
      title="Analyse des Postes"
      bordered={false}
      loading={loading}
      extra={
        <div style={{ display: "flex", gap: 16 }}>
          <Radio.Group
            value={viewMode}
            onChange={(e) => setViewMode(e.target.value)}
            buttonStyle="solid"
          >
            <Radio.Button value="monthly">Mensuel</Radio.Button>
            <Radio.Button value="yearly">Annuel</Radio.Button>
          </Radio.Group>

          {viewMode === "monthly" && (
            <Radio.Group
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              buttonStyle="solid"
            >
              {availableYears.map((year) => (
                <Radio.Button key={year} value={year}>
                  {year}
                </Radio.Button>
              ))}
            </Radio.Group>
          )}
        </div>
      }
    >
      <PostsChart
        posts={posts}
        viewMode={viewMode}
        yearFilter={viewMode === "monthly" ? selectedYear : null}
      />
    </Card>
  );
}

export default PostsAnalysisCard;
